var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"navbar-item",attrs:{"exact":_vm.link.exact,"to":{ name: _vm.link.routerLink }},nativeOn:{"click":function($event){return _vm.routeClicked()}}},[_vm._v(" "+_vm._s(_vm.link.naam)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }